export default {
    enabled: process.env.VUE_APP_MODE === 'jtails', // 啟用/停用SSO相關流程
    key: window.globalData.SHOP_SSO_KEY,
  }
  